/* eslint-disable import/no-cycle */
import { put, takeEvery } from "redux-saga/effects";
import { compnayUsersAction } from "../slice/companyUsers";
import { fetchCompanyUsers } from "../../apis/companyUsers";

export function* getCompanyUsersList({ payload }) {
  try {
    const companyUsers = yield fetchCompanyUsers(payload);

    if (companyUsers?.data?.success) {
      yield put(
        compnayUsersAction.getCompanyUsersSuccess({
          data: companyUsers?.data?.data,
          count: companyUsers?.data?.count,
        })
      );
    } else {
      yield put(
        compnayUsersAction.getCompanyUsersFailed({ errorMessage: companyUsers.data.message })
      );
    }
  } catch (error) {
    yield put(
      compnayUsersAction.getCompanyUsersFailed({
        errorMessage: error.data.data.message || "Something went wrong",
      })
    );
  }
}

export function* watchCompanyUsersAsync() {
  yield takeEvery(compnayUsersAction.getCompanyUsersRequest, getCompanyUsersList);
}
